<script setup>
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { usePrintSelection } from 'dashboard/composables/usePrintSelection';
import ButtonV4 from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['print']);
const { t } = useI18n();
const printSelection = usePrintSelection();

const handlePrint = () => {
  if (printSelection.selectedCount.value === 0) {
    useAlert(t('CONTACT_PANEL.PRINT_SELECTION.EMPTY_ERROR'));
    return;
  }
  emit('print');
};
</script>

<template>
  <div
    v-if="printSelection.isActive.value"
    class="flex items-center justify-between gap-3 px-4 py-2 border-t bg-n-solid-2 border-n-weak"
  >
    <span class="text-sm text-n-slate-11">
      {{
        t('CONTACT_PANEL.PRINT_SELECTION.COUNT', {
          count: printSelection.selectedCount.value,
        })
      }}
    </span>
    <div class="flex items-center gap-2">
      <ButtonV4
        size="sm"
        variant="ghost"
        color="slate"
        :label="t('CONTACT_PANEL.PRINT_SELECTION.CANCEL')"
        @click="printSelection.cancel()"
      />
      <ButtonV4
        size="sm"
        icon="i-lucide-printer"
        :label="t('CONTACT_PANEL.PRINT_SELECTION.PRINT')"
        @click="handlePrint"
      />
    </div>
  </div>
</template>
